import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useOnScrollLoad } from "../../hooks/useOnScrollLoad";


import { createStyles } from "./styles";

var TableBody = function TableBody(props) {
  var children = props.children,className = props.className,onScrollToBottomCallback = props.onScrollToBottomCallback,_props$loading = props.loading,loading = _props$loading === void 0 ? false : _props$loading,id = props.id;

  // React state
  var _useState = useState(0),_useState2 = _slicedToArray(_useState, 2),lastScrollPosition = _useState2[0],setLastScrollPosition = _useState2[1];

  // Component actions
  var scrollingTableBodyRef = useOnScrollLoad(function (scrollTopValue) {
    if (!loading && onScrollToBottomCallback) {
      setLastScrollPosition(scrollTopValue);
      onScrollToBottomCallback();
    }
  });

  // React effects
  //  Returns the scroll position at where it was before the loading started.
  useEffect(function () {var _scrollingTableBodyRe;
    if (!loading && (_scrollingTableBodyRe = scrollingTableBodyRef.current) !== null && _scrollingTableBodyRe !== void 0 && _scrollingTableBodyRe.scrollTop) {
      scrollingTableBodyRef.current.scrollTop = lastScrollPosition || 0;
    }
  }, [loading]);

  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("tbody", { className: clsx(classes.tableBody, className), ref: scrollingTableBodyRef, id: id },
    !children || children.length < 1 ?
    !loading && /*#__PURE__*/
    // eslint-disable-next-line react/jsx-indent
    React.createElement("tr", { className: classes.noDataFallbackRow, id: "no-data-in-table" }, /*#__PURE__*/
    React.createElement("td", { className: classes.noDataFallbackCell }, "No Data")) :


    children));


};
TableBody.displayName = 'TableBody';

export default TableBody;
//# sourceMappingURL=index.js.map